import { wwtMemo } from '@wwt/custom/wwt'

import { wwtPerformanceLog } from '@wwt/core/admin'
import { ReservationDto } from '@wwt/entities/api/search-response'

import { useGuestInformationRoomGuests } from '../../model/useGuestInformationRoomGuests.ts'
import { GuestInformationGrid } from './GuestInformationGrid.tsx'
import { GuestInformationGridElement } from './GuestInformationGridElement.tsx'

interface GuestInformationRoomGuestsProps {
	adultsList: ReservationDto['adultsList']
	childrenList: ReservationDto['childrenList']
	petList: ReservationDto['petList']
}

/**
 * Show passengers and pets from reservation
 *
 * @author Ivan Shchedrovskyi
 */
export const GuestInformationRoomGuests = wwtMemo(
	({ adultsList, childrenList, petList }: GuestInformationRoomGuestsProps) => {
		wwtPerformanceLog('GuestInformationRoomGuests')

		const {
			adultsList: adultsListForRender,
			petList: petListForRender,
			childrenList: childrenListForRender
		} = useGuestInformationRoomGuests(adultsList, childrenList, petList)

		return (
			<div className="flex flex-col gap-y-3">
				<GuestInformationGrid>
					{adultsListForRender.map(element => (
						<GuestInformationGridElement
							key={element.id}
							title={element.title}
							content={element.content}
						/>
					))}
				</GuestInformationGrid>

				<GuestInformationGrid>
					{childrenListForRender.map(element => (
						<GuestInformationGridElement
							key={element.id}
							title={element.title}
							content={element.content}
						/>
					))}
				</GuestInformationGrid>

				<GuestInformationGrid>
					{petListForRender.map(element => (
						<GuestInformationGridElement
							key={element.id}
							title={element.title}
							content={element.content}
						/>
					))}
				</GuestInformationGrid>
			</div>
		)
	}
)
